import { createRef, useCallback, useContext, useEffect } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

export default function useFullscreenHandler() {
  const { fullscreen, setFullscreen } = useContext(TimelinePlayerContext);
  const containerRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (fullscreen) {
      containerRef.current?.requestFullscreen();
    } else if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }, [fullscreen]);

  const fullscreenChange = useCallback(() => {
    if (!document.fullscreenElement) setFullscreen(false);
  }, []);

  useEffect(() => {
    document.addEventListener("fullscreenchange", fullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", fullscreenChange);
    };
  }, []);

  return containerRef;
}
